import { formatDate } from "@certn/utils";
import {
  DateFieldProps as AriaDateFieldProps,
  DateValue,
} from "react-aria-components";

import { _DateField } from "./assets/_DateField";
import { _DateInput } from "./assets/_DateInput";
import { _DateSegment } from "./assets/_DateSegment";
import { _Text } from "../../_assets/_Text";
import {
  FieldErrorsProps,
  FieldErrors,
} from "../_assets/input-wrapper/FieldErrors";
import { FormFeedbackRAC } from "../_assets/input-wrapper/FormFeedbackRAC";
import { FormLabelRAC } from "../_assets/input-wrapper/FormLabelRAC";

export interface DateFieldProps
  extends Omit<AriaDateFieldProps<DateValue>, "children"> {
  testID: string;
  successMessage?: string;
  errors?: FieldErrorsProps["children"];
  info?: React.ReactNode;
  label?: string;
  description?: string;
  locale?: string;
  showFormattedDate?: boolean;
}

export function DateField(props: DateFieldProps) {
  const {
    label,
    description,
    errors,
    locale,
    showFormattedDate = true,
    ...dateFieldProps
  } = props;
  const formattedDate = formatDate(props.value?.toString(), "PP", "", locale);

  return (
    <_DateField {...dateFieldProps}>
      <FormLabelRAC info={props.info} isRequired={props.isRequired}>
        {label}
      </FormLabelRAC>
      <_DateInput>
        {(segment) => {
          return (
            <_DateSegment
              data-testid={`date-selector-${segment.type}-${props.testID}`}
              segment={segment}
            />
          );
        }}
      </_DateInput>
      {formattedDate && showFormattedDate && (
        <_Text style="input/helper" color="text-weak">
          {formattedDate}
        </_Text>
      )}

      <FieldErrors>{props.errors}</FieldErrors>
      <FormFeedbackRAC type="valid">{props.successMessage}</FormFeedbackRAC>
      {description && (
        <div>
          <_Text style="input/helper" color="text-weak">
            {description}
          </_Text>
        </div>
      )}
    </_DateField>
  );
}
